<template>
  <aside class="workspace-sidebar">
    <div class="workspace-brand">
      <span class="logo"></span>
      <span>
        <b>易隆创</b>
        <small>YILONGCHUANG</small>
      </span>
    </div>
    <div class="workspace-role-label">
      <small>当前身份</small>
      <b>{{ role.name }}</b>
    </div>
    <nav class="workspace-menu">
      <button
        v-for="(item, i) in role.menu"
        :key="i"
        :class="{ active: activeMenu === i }"
        @click="activeMenu = i"
      >
        <i>{{ item[0] }}</i>
        <span>{{ item[1] }}</span>
      </button>
    </nav>
    <div class="workspace-sidebar-bottom">
      <button @click="$router.push('/portal')">返回统一身份门户</button>
      <button @click="$router.push('/')">返回生态官网</button>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'WorkspaceSidebar',
  data() { return { activeMenu: 0 }; },
  computed: {
    ...mapState('workspace', ['currentRole']),
    ...mapGetters('workspace', ['currentRoleData']),
    role() { return this.currentRoleData || { name: '', menu: [] }; }
  }
};
</script>

<style lang="less" scoped>
.workspace-sidebar {
  width: 240px;
  background: #02060e;
  border-right: 1px solid var(--line);
  display: flex;
  flex-direction: column;
  padding: 20px 14px;
  flex-shrink: 0;

}

.workspace-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 6px 20px;
  border-bottom: 1px solid rgba(255,255,255,.06);
  margin-bottom: 18px;

  b { color: #fff; font-size: 14px; display: block; }
  small { color: #71809a; font-size: 9px; display: block; }

}

.logo {
  width: 32px; height: 32px; border-radius: 9px;
  background: linear-gradient(135deg, var(--cyan), #2875ec);
  display: grid; place-items: center; flex-shrink: 0;
  &::before { content: "易"; color: #fff; font-weight: 800; font-size: 15px; }
}

.workspace-role-label {
  padding: 10px 8px; border-radius: 12px;
  background: rgba(67, 217, 255, 0.06); border: 1px solid rgba(67, 217, 255, 0.12);
  margin-bottom: 18px;
  small { color: #64718e; font-size: 10px; }
  b { display: block; color: #86dcff; font-size: 14px; margin-top: 2px; }

}

.workspace-menu {
  flex: 1;
  display: grid;
  gap: 4px;

  button {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 10px;
    border: 0;
    background: transparent;
    color: #8794ae;
    border-radius: 12px;
    cursor: pointer;
    font-size: 13px;
    transition: 0.2s;

    i {
      width: 28px; height: 28px;
      border-radius: 8px;
      background: rgba(255,255,255,.05);
      display: grid; place-items: center;
      font-style: normal; font-size: 14px;
      flex-shrink: 0;
    }

    &:hover { background: rgba(255,255,255,.04); color: #c0cce4; }
    &.active { background: rgba(67, 217, 255, 0.10); color: #fff; }
    &.active i { background: rgba(67, 217, 255, 0.18); }

  }
}

.workspace-sidebar-bottom {
  border-top: 1px solid rgba(255,255,255,.06);
  padding-top: 14px;
  display: grid;
  gap: 4px;

  button {
    padding: 10px;
    border: 0;
    background: transparent;
    color: #5f6d8a;
    cursor: pointer;
    font-size: 12px;
    text-align: left;
    border-radius: 8px;
    &:hover { color: #fff; background: rgba(255,255,255,.03); }

  }
}
</style>
